import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { Contact } from "../../types/Contact";

export const getContact = (contactId: string, options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["contact", contactId],
    queryFn: (): Promise<Contact> => {
      return fetchWithAuth<Contact>("getContact", contactId);
    },
    enabled: isQueryEnabled(options),
  });
};
